'use strict';
define([
    'angular',
    'modules/leadgeneration/landing/landing.controller'
], function (angular, LeadGenerationLandingCtrl) {
    var app = angular.module('app.leadgeneration.landing', []);
    app.controller('LeadGenerationLandingCtrl', LeadGenerationLandingCtrl);
    return app;
});
